import * as angular from "angular";
import * as _ from "lodash";

export class PolylineService {

  constructor(private $log) {
  }

  clearPolyline(polyline) {
    if (polyline) {
      polyline.setMap(null);
    }
  }

  clearPolylines(_polylines) {
    if (_.isUndefined(_polylines)) {
      this.$log.error('Polylines resolved to undefined! \n' +
        '-->polyline@clearPolylines');
    } else {

      if (_.isArray(_polylines)) {

        _.forEach(_polylines, (_polyline) => {
          this.clearPolyline(_polyline);
        });

      } else {
        this.$log.error('Polylines is not an array! \n' +
          '-->polyline@clearPolylines');
      }

    }
  }

  showPolyline(map, polyline) {
    if (polyline) {
      polyline.setMap(map);
    }
  }

  createPolyline(_map?, _markers?, isCompletedItinerary?) {
    // make sure all markers are valid before drawing line
    const found = _.indexOf(_markers, undefined);

    if (!_.isEqual(found, -1) || _.isEmpty(_markers)) {
      return null;
    }

    const polylinePath = _.map(_markers, function (_marker) {
      return {
        lat: _marker.position.lat(),
        lng: _marker.position.lng()
      };
    });

    const polylineOptions: any = {
      path: polylinePath,
      map: _map,
      strokeColor: isCompletedItinerary ? '#3bcaf8' : '#2196F3',
      strokeWeight: 2,
      strokeOpacity: 1,
      clickable: false,
      zIndex: google.maps.Marker.MAX_ZINDEX
    };

    if (isCompletedItinerary) {
      polylineOptions.strokeOpacity = 0;
      polylineOptions.icons = [
        {
          repeat: '15px',
          icon: {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            scale: 3
          },
          offset: '0'
        }
      ]
    } else {
      polylineOptions.icons = [
        {
          repeat: '150px', //CHANGE THIS VALUE TO CHANGE THE DISTANCE BETWEEN ARROWS
          icon: {
            path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
          },
          offset: '100%'
        }
      ]
    }

    return new google.maps.Polyline(polylineOptions);
  }

  refreshPolyline(polyline, markers) {
    if (polyline) {
      const polylinePath = _.map(markers, (marker) => {
        return {
          lat: marker.position.lat(),
          lng: marker.position.lng()
        };
      });

      polyline.setPath(polylinePath);
    }
  }

}

angular
  .module('bringoz.admin.map')
  .service('polylineService', PolylineService);
